import styled from '@emotion/styled';
import { Button, MenuItem, TextField } from '@mui/material';

export const ComboBoxContainer = styled('div')({
  display: 'inline-flex',
  marginBottom: '24px'
});

export const StyledAutoComplete = {
  width: '720px',
  height: '40px',
  background: 'transparent',
  '&:hover': {
    '& .MuiAutocomplete-inputRoot': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#5F65F6'
      }
    }
  },
  '&.Mui-focused': {
    '& .MuiAutocomplete-inputRoot': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#5F65F6',
        borderWidth: '1px'
      }
    }
  }
};

export const StyledMenuItem = styled(MenuItem)({
  fontWeight: '400px',
  fontSize: '14px',
  fontFamily: 'Open Sans'
});

export const AddButton = styled(Button)({
  marginLeft: '14px',
  marginBottom: '2.5px',
  color: '#3F51B5',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '61px',
  height: '37.5px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  }
});

export const ListItem = {
  fontWeight: '400px',
  fontSize: '14px',
  fontFamily: 'Open Sans'
};

export const AutoCompleteInput = styled(TextField)(ListItem);
